import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import requester from '@/requester';
import { useAuthStore } from '@/store';
import { ability } from '@/plugins/casl';

import PainelDeControle from '@/pages/PainelDeControle.vue';
import ErroNaoEncontrado from '@/pages/erro/ErroNaoEncontrado.vue';

import authRoutes from './auth.routes';
import amostrasCatalisadoresRoutes from './amostras-catalisadores.routes';
import amostrasComerciaisRoutes from './amostras-comerciais.routes';
import amostrasPlacasRoutes from './amostras-placas.routes';
import amostrasRoutes from './amostras.routes';
import amostrasUtingaRoutes from './amostras-utinga.routes';
import bagsRoutes from './bags.routes';
import balancasRoutes from './balancas.routes';
import fornecedoresSapIndex from './fornecedores-sap.routes';
import pedidosSapIndex from './pedidos-sap.routes';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'PainelDeControle',
    component: PainelDeControle,
    meta: {
      icon: 'mdi-view-dashboard',
    },
  },
  ...authRoutes,
  ...amostrasRoutes,
  ...amostrasCatalisadoresRoutes,
  ...amostrasPlacasRoutes,
  ...amostrasComerciaisRoutes,
  ...amostrasUtingaRoutes,
  ...bagsRoutes,
  ...balancasRoutes,
  ...fornecedoresSapIndex,
  ...pedidosSapIndex,
  {
    path: '*',
    name: 'ErroNaoEncontrado',
    component: ErroNaoEncontrado,
    meta: {
      public: true,
      layout: 'Public',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
  try {
    // lembrando que store não está persistente, então toda nova página/aba, pegamos as informações do usuário
    const usuarioStore = useAuthStore().usuario;
    if (!usuarioStore || to.name === 'AuthLogin') {
      // verifica se cookie está com uma sessão válida
      const usuarioCookie = await requester.auth.checkSession();

      ability.update(usuarioCookie.permissoes); // atualiza permissoes
      useAuthStore().login(usuarioCookie); // salva usuario na store
    }

    // se rota for de login e chegou até aqui, é porque já tá logado
    if (to.name === 'AuthLogin') {
      next({ name: 'PainelDeControle' });
      return;
    }

    // se usuario não tem permissao, redireciona pra home
    const rules = to?.meta?.rules || [];
    if (!rules.every((rule) => ability.can(rule?.action, rule?.subject))) {
      next({ name: 'PainelDeControle' });
      return;
    }

    // tudo certo, segue em frente
    next();
  } catch (err) {
    // verifica se sistema está na versão correta
    const version = err?.response?.headers?.['katalis-version'];
    if (version && version !== localStorage.getItem('katalis-version')) {
      localStorage.setItem('katalis-version', version);
      window.location.reload();
      return;
    }
    // se rota for pública, segue em frente
    if (to?.meta?.public) {
      next();
      return;
    }
    // se não, redireciona pra tela de login
    next({
      name: 'AuthLogin',
      query: { redirect: to.path },
    });
  }
});

export default router;
